// v3.4.492 — الشاشة التفاعلية الموحّدة (تاب رئيسي): «رابط الشاشة» (الرابط + المشاريع الظاهرة وترتيبها)
// ثم تاب لكل مشروع مفعّل على الشاشة: بطاقته في الشاشة الرئيسية (العنوان/الوصف/الغلاف) + كل ملفات شاشته (ScreenContentTab)
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { screenMedia } from "../services/api";
import { ScreenContentTab } from "./ProjectsPage";

const card = { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 14, padding: 18, marginBottom: 16 };
const inp = { width: "100%", padding: "9px 11px", border: "1px solid #e2e8f0", borderRadius: 9, fontFamily: "inherit", fontSize: 13.5, boxSizing: "border-box", background: "#fff" };
const lbl = { display: "block", fontSize: 12, fontWeight: 800, color: "#475569", marginBottom: 5 };
const btn = (bg, fg = "#fff", bd) => ({ padding: "8px 14px", borderRadius: 9, border: bd ? "1px solid " + bd : "none", background: bg, color: fg, fontWeight: 800, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 });
const SEC_ICON = { cover: "🖼️", intro_video: "🎬", site_video: "🚁", site_image: "🛰️", gallery: "📷", plans: "📐", brochure: "📖" }; // v3.4.506

export default function ScreenAdminPage() {
  const { pid } = useParams();
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    setErr(null);
    return screenMedia.overview().then(r => setD(r.data)).catch(e => setErr(e.response?.data?.error || e.message));
  }, []);
  useEffect(() => { load(); }, [load]);
  const changed = () => { load(); window.dispatchEvent(new Event("screen-projects-changed")); };

  if (err) return <div style={{ padding: 40, textAlign: "center", color: "#b91c1c" }}>{err}</div>;
  if (!d) return <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>جارٍ التحميل…</div>;

  const canManage = !!d.can_manage;
  const enabled = d.projects.filter(p => p.enabled);
  const cur = pid ? d.projects.find(p => String(p.id) === String(pid)) : null;
  const hubUrl = `${window.location.origin}/screen/`;
  const projUrl = (id) => `${window.location.origin}/screen/project.html?p=${id}`;
  const copy = (t) => { try { navigator.clipboard.writeText(t); toast.success("نُسخ الرابط"); } catch { window.prompt("انسخ الرابط:", t); } };

  const toggle = async (p) => {
    setBusy(p.id);
    try { await screenMedia.setEnabled(p.id, !p.enabled); toast.success(p.enabled ? `أُخفي «${p.name}» من الشاشة` : `«${p.name}» يظهر الآن على الشاشة`); changed(); }
    catch (e) { toast.error(e.response?.data?.error || "فشل الحفظ"); }
    setBusy(false);
  };
  const move = async (p, dir) => {
    const ids = enabled.map(x => x.id); const i = ids.indexOf(p.id), j = i + dir;
    if (i < 0 || j < 0 || j >= ids.length) return;
    [ids[i], ids[j]] = [ids[j], ids[i]];
    setBusy(p.id);
    try { await screenMedia.order(ids); changed(); } catch (e) { toast.error(e.response?.data?.error || "فشل الترتيب"); }
    setBusy(false);
  };

  const tabBtn = (active, label, onClick, key) => (
    <button key={key} type="button" onClick={onClick}
      style={{ padding: "9px 16px", background: active ? "#0f766e" : "#fff", color: active ? "#fff" : "#334155", border: "1px solid " + (active ? "#0f766e" : "#e2e8f0"), borderRadius: 10, fontSize: 13, fontWeight: active ? 900 : 700, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>{label}</button>
  );

  return (
    <div dir="rtl" style={{ padding: 20, maxWidth: 1400, margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14, flexWrap: "wrap" }}>
        <div style={{ flex: 1 }}>
          <h2 style={{ margin: 0, fontSize: 21, fontWeight: 900, color: "#0f172a" }}>🖥️ الشاشة التفاعلية</h2>
          <div style={{ fontSize: 12.5, color: "#64748b", marginTop: 3 }}>شاشة موحّدة لكل المشاريع: الشاشة الرئيسية تعرض صورة لكل مشروع، والضغط عليها يفتح شاشته التفاعلية</div>
        </div>
        <a href={hubUrl} target="_blank" rel="noreferrer" style={btn("#0f766e")}>فتح الشاشة ↗</a>
      </div>

      {/* التابات: الرابط ثم تاب لكل مشروع مفعّل */}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 16, paddingBottom: 12, borderBottom: "2px solid #e2e8f0" }}>
        {tabBtn(!pid, "🔗 رابط الشاشة والمشاريع", () => nav("/screen-admin"), "link")}
        {enabled.map(p => tabBtn(String(p.id) === String(pid), "🏢 " + (p.title || p.name), () => nav(`/screen-admin/${p.id}`), p.id))}
        {cur && !cur.enabled && tabBtn(true, "🏢 " + cur.name + " (غير ظاهر)", () => {}, "cur")}
      </div>

      {!pid ? (
        <>
          <div style={card}>
            <div style={{ fontSize: 15, fontWeight: 900, color: "#0f172a", marginBottom: 8 }}>🔗 رابط الشاشة الموحّدة</div>
            <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
              <input readOnly value={hubUrl} dir="ltr" style={{ ...inp, flex: "1 1 320px", fontFamily: "monospace", background: "#f8fafc" }} onFocus={e => e.target.select()} />
              <button type="button" onClick={() => copy(hubUrl)} style={btn("#f1f5f9", "#334155", "#e2e8f0")}>📋 نسخ</button>
              <a href={hubUrl} target="_blank" rel="noreferrer" style={btn("#0f766e")}>فتح ↗</a>
            </div>
            <div style={{ fontSize: 12, color: "#64748b", marginTop: 10, lineHeight: 1.9 }}>
              • الدخول بحساب «تطبيق المنظم التسويقي» (الجوال + كلمة السر)، ويبقى الجهاز مسجّلًا 30 يومًا.<br />
              • الشاشة الرئيسية تعرض المشاريع الظاهرة أدناه بترتيبها؛ صورة البطاقة = «صورة المشروع في الشاشة الرئيسية» (وإلا الصورة الجوية ثم أول صورة).<br />
              • تسجيلات «سجّل اهتمامك» تصل إلى «وارد العملاء» ومعها اسم المشروع الذي سُجّلت منه.
            </div>
          </div>

          <div style={card}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
              <div style={{ fontSize: 15, fontWeight: 900, color: "#0f172a", flex: 1 }}>🏢 المشاريع على الشاشة</div>
              <span style={{ fontSize: 12, color: "#64748b" }}>{enabled.length} ظاهر من {d.projects.length}</span>
            </div>
            {!canManage && <div style={{ fontSize: 12, color: "#b45309", marginBottom: 10 }}>عرض فقط — إدارة الشاشة تتطلب صلاحية «إدارة المشاريع والملفات على الشاشة»</div>}
            <div style={{ display: "grid", gap: 10 }}>
              {d.projects.map((p) => {
                const ei = enabled.findIndex(x => x.id === p.id);
                const counts = p.counts || {};
                return (
                  <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: 10, border: "1px solid " + (p.enabled ? "#99f6e4" : "#e2e8f0"), background: p.enabled ? "#f0fdfa" : "#fff", borderRadius: 12, flexWrap: "wrap" }}>
                    <div style={{ width: 120, height: 72, borderRadius: 9, overflow: "hidden", background: "#0f172a", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", color: "#c9a96a", fontSize: 28, fontWeight: 900 }}>
                      {p.cover_url ? <img src={p.cover_url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} loading="lazy" /> : (p.name || "").trim().charAt(0)}
                    </div>
                    <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                      <div style={{ fontSize: 14.5, fontWeight: 900, color: "#0f172a" }}>
                        {p.enabled && <span style={{ fontFamily: "monospace", color: "#0f766e", marginInlineEnd: 6 }}>{String(ei + 1).padStart(2, "0")}</span>}
                        {p.title || p.name}{p.title && p.title !== p.name && <span style={{ fontSize: 11.5, color: "#94a3b8", fontWeight: 600 }}> ({p.name})</span>}
                      </div>
                      <div style={{ fontSize: 11.5, color: "#64748b", marginTop: 3, display: "flex", gap: 10, flexWrap: "wrap" }}>
                        {Object.keys(d.sections).map(k => <span key={k} title={d.sections[k].label} style={{ opacity: counts[k]?.visible ? 1 : .45 }}>{SEC_ICON[k] || "•"} {counts[k]?.visible || 0}</span>)}
                        {!p.has_cover && p.enabled && <span style={{ color: "#b45309", fontWeight: 700 }}>⚠ بلا صورة غلاف</span>}
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
                      {p.enabled && canManage && <>
                        <button type="button" disabled={busy === p.id || ei === 0} onClick={() => move(p, -1)} title="تقديم" style={btn("#fff", "#334155", "#e2e8f0")}>↑</button>
                        <button type="button" disabled={busy === p.id || ei === enabled.length - 1} onClick={() => move(p, 1)} title="تأخير" style={btn("#fff", "#334155", "#e2e8f0")}>↓</button>
                      </>}
                      {canManage && (
                        <button type="button" disabled={busy === p.id} onClick={() => toggle(p)}
                          style={btn(p.enabled ? "#fef3c7" : "#16a34a", p.enabled ? "#92400e" : "#fff")}>{p.enabled ? "🙈 إخفاء من الشاشة" : "➕ إظهار على الشاشة"}</button>
                      )}
                      {p.enabled && <button type="button" onClick={() => nav(`/screen-admin/${p.id}`)} style={btn("#0f766e")}>📂 الملفات</button>}
                      {p.enabled && <a href={projUrl(p.id)} target="_blank" rel="noreferrer" title="فتح شاشة هذا المشروع مباشرة" style={btn("#fff", "#0f766e", "#99f6e4")}>↗</a>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      ) : !cur ? (
        <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>المشروع غير موجود</div>
      ) : (
        <ProjectScreenTab key={cur.id} p={cur} canManage={canManage} isAdmin={!!d.is_admin} onChanged={changed} projUrl={projUrl(cur.id)} copy={copy} />
      )}
    </div>
  );
}

function ProjectScreenTab({ p, canManage, isAdmin, onChanged, projUrl, copy }) {
  const [title, setTitle] = useState(p.title || "");
  const [subtitle, setSubtitle] = useState(p.subtitle || "");
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try { await screenMedia.setMeta(p.id, { title, subtitle }); toast.success("✅ حُفظت بطاقة المشروع — تظهر على الشاشة فورًا"); onChanged(); }
    catch (e) { toast.error(e.response?.data?.error || "فشل الحفظ"); }
    setSaving(false);
  };
  return (
    <>
      <div style={{ ...card, display: "flex", gap: 18, flexWrap: "wrap", alignItems: "stretch" }}>
        <div style={{ width: 300, maxWidth: "100%", aspectRatio: "4 / 5", borderRadius: 16, overflow: "hidden", position: "relative", background: "radial-gradient(ellipse at center,#2a2112,#0b0906)", flexShrink: 0, boxShadow: "0 10px 30px rgba(0,0,0,.25)" }}>
          {p.cover_url && <img src={p.cover_url} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />}
          <div style={{ position: "absolute", inset: 0, background: "linear-gradient(180deg,rgba(0,0,0,.1) 30%,rgba(0,0,0,.9))" }} />
          <div style={{ position: "absolute", right: 16, left: 16, bottom: 16, color: "#fff" }}>
            <div style={{ fontSize: 24, fontWeight: 900, lineHeight: 1.2 }}>{title || p.name}</div>
            {subtitle && <div style={{ fontSize: 12.5, opacity: .8, marginTop: 4 }}>{subtitle}</div>}
            <div style={{ marginTop: 10, display: "inline-block", padding: "6px 14px", borderRadius: 999, background: "linear-gradient(135deg,#f0dfb3,#c9a96a 55%,#b48f4a)", color: "#17120a", fontSize: 12, fontWeight: 800 }}>استكشف المشروع ←</div>
          </div>
        </div>
        <div style={{ flex: "1 1 320px" }}>
          <div style={{ fontSize: 15, fontWeight: 900, color: "#0f172a", marginBottom: 4 }}>🪪 بطاقة المشروع في الشاشة الرئيسية</div>
          <div style={{ fontSize: 12, color: "#64748b", marginBottom: 12 }}>المعاينة يمين: هكذا تظهر البطاقة في الشاشة الموحّدة. الصورة من قسم «صورة المشروع في الشاشة الرئيسية» أدناه.</div>
          <label style={lbl}>اسم المشروع على الشاشة</label>
          <input value={title} onChange={e => setTitle(e.target.value)} placeholder={p.name} disabled={!canManage} style={{ ...inp, marginBottom: 10 }} />
          <label style={lbl}>الوصف (سطر تحت الاسم)</label>
          <input value={subtitle} onChange={e => setSubtitle(e.target.value)} placeholder="مثال: أيقونة الفخامة بقلب مدينة جدة — مخطط درب الحرمين" disabled={!canManage} style={{ ...inp, marginBottom: 12 }} />
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {canManage && <button type="button" onClick={save} disabled={saving} style={btn("#0f766e")}>{saving ? "جارٍ الحفظ…" : "💾 حفظ البطاقة"}</button>}
            <a href={projUrl} target="_blank" rel="noreferrer" style={btn("#fff", "#0f766e", "#99f6e4")}>فتح شاشة المشروع ↗</a>
            <button type="button" onClick={() => copy(projUrl)} style={btn("#f1f5f9", "#334155", "#e2e8f0")}>📋 نسخ رابط المشروع</button>
          </div>
        </div>
      </div>
      <div style={{ ...card, padding: 0 }}>
        <ScreenContentTab project={{ id: p.id, name: p.name }} canManage={canManage} isAdmin={isAdmin} onChanged={onChanged} />
      </div>
    </>
  );
}
